function footerNewsletterForm() {
    const el = document.getElementById('footer-newsletter-config');
    const config = el ? JSON.parse(el.textContent) : {
        hcaptchaEnabled: false,
        hcaptchaSiteKey: '',
        hcaptchaSize: 'compact',
        messages: {
            validEmail: 'Please enter a valid email address',
            captchaError: 'Please complete the captcha verification',
            subSuccess: 'Subscription successful!',
            errorRetry: 'An error occurred. Please try again.'
        }
    };

    return {
        email: '',
        message: '',
        showMessage: false,
        isSuccess: false,
        isLoading: false,
        isFormValid: false,
        hcaptchaCompleted: !config.hcaptchaEnabled,
        hcaptchaWidgetId: null,

        checkFormValidity() {
            let isValid = true;

            if (!this.email || !this.email.includes('@')) {
                isValid = false;
            }

            if (config.hcaptchaEnabled && !this.hcaptchaCompleted) {
                isValid = false;
            }

            this.isFormValid = isValid;
            return isValid;
        },

        async submitForm() {
            this.showMessage = false;

            if (!this.email || !this.email.includes('@')) {
                this.message = config.messages.validEmail;
                this.isSuccess = false;
                this.showMessage = true;
                return;
            }

            if (config.hcaptchaEnabled) {
                const hcaptchaResponse = document.getElementById('footer-hcaptcha-response')?.value;
                if (!hcaptchaResponse) {
                    this.message = config.messages.captchaError;
                    this.isSuccess = false;
                    this.showMessage = true;
                    return;
                }
            }

            this.isLoading = true;

            try {
                const response = await fetch(window.location.href, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        workflows: ['change_email_list'],
                        jinja_data: {
                            email_address: this.email,
                            status: 'subscribed'
                        }
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const contentType = response.headers.get('content-type');
                if (!contentType || !contentType.includes('application/json')) {
                    throw new Error('Server returned HTML instead of JSON. Check backend configuration.');
                }

                const data = await response.json();

                if (data.result) {
                    this.message = data.result;
                    this.isSuccess = data.success === 1;
                } else if (data.message) {
                    this.message = data.message;
                    this.isSuccess = data.success === 1 || data.success === true || data.type === 'success';
                } else {
                    this.message = config.messages.subSuccess;
                    this.isSuccess = true;
                }

                this.showMessage = true;

                if (this.isSuccess) {
                    this.email = '';
                    if (config.hcaptchaEnabled) {
                        this.resetHcaptcha();
                    }
                }
            } catch (error) {
                this.message = error.message || config.messages.errorRetry;
                this.isSuccess = false;
                this.showMessage = true;
                if (config.hcaptchaEnabled) {
                    this.resetHcaptcha();
                }
            } finally {
                this.isLoading = false;
            }
        },

        resetHcaptcha() {
            if (!config.hcaptchaEnabled) return;
            setTimeout(() => {
                try {
                    const container = document.getElementById('footer-hcaptcha-container');
                    const responseField = document.getElementById('footer-hcaptcha-response');

                    if (responseField) {
                        responseField.value = '';
                    }

                    if (typeof hcaptcha !== 'undefined' && container && this.hcaptchaWidgetId !== null) {
                        try {
                            hcaptcha.reset(this.hcaptchaWidgetId);
                        } catch (e) {
                            console.error('Error resetting hCaptcha widget:', e);
                        }
                    }

                    this.hcaptchaCompleted = false;
                    this.checkFormValidity();
                } catch (e) {
                    console.error('Error resetting footer hCaptcha:', e);
                }
            }, 100);
        },

        getHcaptchaTheme() {
            return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        },

        init() {
            this.checkFormValidity();
            this.$watch('email', () => this.checkFormValidity());

            if (!config.hcaptchaEnabled) return;

            const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
            darkModeQuery.addEventListener('change', () => {
                if (this.hcaptchaWidgetId !== null) {
                    const container = document.getElementById('footer-hcaptcha-container');
                    if (container && typeof hcaptcha !== 'undefined') {
                        try {
                            hcaptcha.remove(this.hcaptchaWidgetId);
                            this.hcaptchaWidgetId = null;
                            this.hcaptchaCompleted = false;
                            this.checkFormValidity();
                            setTimeout(() => renderFooterCaptcha(), 100);
                        } catch (e) {
                            console.error('Error updating hCaptcha theme:', e);
                        }
                    }
                }
            });

            const renderFooterCaptcha = () => {
                const container = document.getElementById('footer-hcaptcha-container');
                if (container && typeof hcaptcha !== 'undefined' && !container.hasChildNodes()) {
                    try {
                        this.hcaptchaWidgetId = hcaptcha.render(container, {
                            sitekey: config.hcaptchaSiteKey,
                            size: config.hcaptchaSize,
                            theme: this.getHcaptchaTheme(),
                            callback: (token) => {
                                document.getElementById('footer-hcaptcha-response').value = token;
                                this.hcaptchaCompleted = true;
                                this.checkFormValidity();
                            },
                            'expired-callback': () => {
                                document.getElementById('footer-hcaptcha-response').value = '';
                                this.hcaptchaCompleted = false;
                                this.checkFormValidity();
                            },
                            'error-callback': () => {
                                document.getElementById('footer-hcaptcha-response').value = '';
                                this.hcaptchaCompleted = false;
                                this.checkFormValidity();
                            }
                        });
                    } catch (e) {
                        console.error('Error rendering footer hCaptcha:', e);
                    }
                }
            };

            const loadHcaptchaScript = (callback) => {
                if (typeof hcaptcha !== 'undefined') {
                    callback();
                    return;
                }
                if (!window.hcaptchaScriptLoaded) {
                    window.hcaptchaScriptLoaded = true;
                    const script = document.createElement('script');
                    script.src = 'https://js.hcaptcha.com/1/api.js?render=explicit';
                    script.async = true;
                    script.defer = true;
                    script.onload = () => window.dispatchEvent(new Event('hcaptchaLoaded'));
                    document.head.appendChild(script);
                }
                window.addEventListener('hcaptchaLoaded', callback, { once: true });
            };

            const footerCaptchaContainer = document.getElementById('footer-hcaptcha-container');
            if (footerCaptchaContainer && 'IntersectionObserver' in window) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            observer.disconnect();
                            loadHcaptchaScript(renderFooterCaptcha);
                        }
                    });
                }, { threshold: 0.1 });
                observer.observe(footerCaptchaContainer);
            } else if (footerCaptchaContainer) {
                loadHcaptchaScript(renderFooterCaptcha);
            }
        }
    };
}

window.footerNewsletterForm = footerNewsletterForm;
